import apiService from './apiService';

/**
 * Service de persistance serveur du panier (lié au client connecté).
 */
class CartService {
  /**
   * Récupère le panier du client connecté
   * @returns {Promise<Array>} la liste des articles
   */
  async getCart() {
    const response = await apiService.get('/cart');
    return Array.isArray(response?.data) ? response.data : [];
  }

  /**
   * Remplace le contenu du panier serveur
   * @param {Array} items
   * @returns {Promise<Array>}
   */
  async saveCart(items) {
    const response = await apiService.put('/cart', { items: Array.isArray(items) ? items : [] });
    return Array.isArray(response?.data) ? response.data : [];
  }

  /**
   * Vide le panier serveur
   */
  async clearCart() {
    const response = await apiService.delete('/cart');
    return Array.isArray(response?.data) ? response.data : [];
  }
}

const cartServiceInstance = new CartService();
export default cartServiceInstance;
